import React from "react";

export const GRANT_STATUS = {
  APPLIED: "10",       
  ACCEPTED: "11",        
  REJECTED: "12",        
  IN_PROGRESS: "13",     
  AWAITING_DOCUMENTS: "14", 
  DOCUMENT_RESUBMITTED: "15", 
  APPROVED: "16",        
  REJECTED_FINAL: "17",  
  

  FORWARDED: ["11", "13", "14", "15", "16", "17"], 
  PENDING: ["11", "13", "14", "15"], 
  FINAL: ["16", "17"],   
};


export const getStatusName = (statusId) => {
  switch (statusId) {
    case "10": return "Grant Applied By ESM";
    case "11": return "Grant Accepted";
    case "12": return "Grant Rejected";
    case "13": return "Grant Approval in progress";
    case "14": return "Awaiting Documents from ESM";
    case "15": return "Document Resubmitted by ESM";
    case "16": return "Grant Approved by Branch User";
    case "17": return "Grant Rejected By Branch User";
    case "19": return "Escalated to Next Level";
    // "19" : "" addd for escalted
    default: return "Unknown Status";
  }
};

// Get allowed actions per role
export const getAllowedActions = (userRole, currentStatusId) => {
  
  // Role 3: Branch User
   if (userRole === 3 || userRole === 10) {
    
    if (currentStatusId === GRANT_STATUS.ACCEPTED || currentStatusId === GRANT_STATUS.APPLIED) {
      return [
        //         {
        //   id: GRANT_STATUS.ACCEPTED,
        //   label: "Accepted",
        //   icon: "bi-check-circle",
        //   buttonClass: "aresa-button-success",
        //   description: "Accepted this grant"
        // },

        //         {
        //   id: GRANT_STATUS.REJECTED,
        //   label: "Reject",
        //   icon: "bi-x-circle",
        //   buttonClass: "aresa-button-danger",
        //   description: "Rejected this grant it is not valid"
        // },
        {
          id: GRANT_STATUS.IN_PROGRESS,
          label: "Mark In Progress",
          icon: "bi-hourglass-split",
          buttonClass: "aresa-button-info",
          description: "Mark this grant as in progress"
        },
        {
          id: GRANT_STATUS.AWAITING_DOCUMENTS,
          label: "Request Documents",
          icon: "bi-file-earmark-arrow-down",
          buttonClass: "aresa-button-warning",
          description: "Request additional documents from ESM"
        },
        {
          id: GRANT_STATUS.APPROVED,
          label: "Approve Grant",
          icon: "bi-check-circle",
          buttonClass: "aresa-button-success",
          description: "Approve this grant"
        },
        {
          id: GRANT_STATUS.REJECTED_FINAL,
          label: "Reject Grant",
          icon: "bi-x-circle",
          buttonClass: "aresa-button-danger",
          description: "Reject this grant"
        }
      ];
    } 
    // Actions for IN_PROGRESS status
    else if (currentStatusId === GRANT_STATUS.IN_PROGRESS) {
      return [
        {
          id: GRANT_STATUS.IN_PROGRESS,
          label: "Mark In Progress",
          icon: "bi-hourglass-split",
          buttonClass: "aresa-button-info",
          description: "Mark this grant as in progress"
        },
        {
          id: GRANT_STATUS.AWAITING_DOCUMENTS,
          label: "Request Documents",
          icon: "bi-file-earmark-arrow-down",
          buttonClass: "aresa-button-warning",
          description: "Request additional documents from ESM"
        },
        {
          id: GRANT_STATUS.APPROVED,
          label: "Approve Grant",
          icon: "bi-check-circle",
          buttonClass: "aresa-button-success",
          description: "Approve this grant"
        },
        {
          id: GRANT_STATUS.REJECTED_FINAL,
          label: "Reject Grant",
          icon: "bi-x-circle",
          buttonClass: "aresa-button-danger",
          description: "Reject this grant"
        }
      ];
    }
    // Actions when documents have been resubmitted by ESM
    else if (currentStatusId === GRANT_STATUS.DOCUMENT_RESUBMITTED) {
      return [
        {
          id: GRANT_STATUS.IN_PROGRESS,
          label: "Continue Processing",
          icon: "bi-hourglass-split",
          buttonClass: "aresa-button-info",
          description: "Continue processing this grant"
        },
        {
          id: GRANT_STATUS.AWAITING_DOCUMENTS,
          label: "Request More Documents",
          icon: "bi-file-earmark-arrow-down",
          buttonClass: "aresa-button-warning",
          description: "Request additional documents from ESM"
        },
        {
          id: GRANT_STATUS.APPROVED,
          label: "Approve Grant",
          icon: "bi-check-circle",
          buttonClass: "aresa-button-success",
          description: "Approve this grant"
        },
        {
          id: GRANT_STATUS.REJECTED_FINAL,
          label: "Reject Grant",
          icon: "bi-x-circle",
          buttonClass: "aresa-button-danger",
          description: "Reject this grant"
        }
      ];
    }
    return []; 
  }
  
  // Role 4 & 5: DGAR and COLA - View only, no actions
  else if (userRole === 4 || userRole === 5 ||userRole === 6 || userRole === 7 || userRole==8  ) {
    return [];
  }
  
  return [];
};


export const canUpdateStatus = (userRole, currentStatusId) => {

  
  // Role 3: Branch User and Section user Grant
   if (userRole === 3 || userRole === 10) {
    return (
      currentStatusId === GRANT_STATUS.APPLIED ||
      currentStatusId === GRANT_STATUS.ACCEPTED || 
      currentStatusId === GRANT_STATUS.IN_PROGRESS || 
      currentStatusId === GRANT_STATUS.DOCUMENT_RESUBMITTED
    );
  }
  

  return false;
};


export const canUploadDocuments = (userRole) => {
  // Only Branch users can upload documents
  return userRole === 3 || userRole === 10;
};


export const isGrantInFinalState = (statusId) => {
  return GRANT_STATUS.FINAL.includes(statusId);
};


export const getStatusMessage = (currentStatusId) => {
  switch (currentStatusId) {
    case GRANT_STATUS.APPROVED:
      return {
        title: "This grant has been approved",
        description: "This grant application has been approved and processed.",
        type: "success"
      };
    case GRANT_STATUS.REJECTED_FINAL:
      return {
        title: "This grant has been rejected",
        description: "This grant application has been rejected.",
        type: "warning"
      };
    case GRANT_STATUS.REJECTED:
      return {
        title: "This grant has been rejected",
        description: "This grant application cannot be processed further.",
        type: "warning"
      };
    case GRANT_STATUS.DOCUMENT_RESUBMITTED:
      return {
        title: "Documents Resubmitted by ESM",
        description: "The ESM has resubmitted the requested documents. Please review and take appropriate action.",
        type: "info"
      };
    case GRANT_STATUS.AWAITING_DOCUMENTS:
      return {
        title: "Awaiting documents from ESM",
        description: "Request for additional documents has been sent to ESM.",
        type: "info"
      };
    default:
      return {
        title: `Current status: ${getStatusName(currentStatusId)}`,
        description: "Please check the timeline for more details.",
        type: "info"
      };
  }
};

// Get message when status cannot be updated
export const getCannotUpdateMessage = (statusId) => {
  if (statusId === GRANT_STATUS.ACCEPTED) {
    return "This grant has already been accepted. No further updates are allowed.";
  } else if (statusId === GRANT_STATUS.REJECTED) {
    return "This grant has been rejected. No further updates are allowed.";
  } else if (GRANT_STATUS.FINAL.includes(statusId)) {
    return statusId === GRANT_STATUS.APPROVED 
      ? "This grant has been approved. No further updates are allowed."
      : "This grant has been rejected. No further updates are allowed.";
  } else {
    return "This grant cannot be updated at this time.";
  }
};

export default {
  GRANT_STATUS,
  getStatusName,
  getAllowedActions,
  canUpdateStatus,
  canUploadDocuments,
  isGrantInFinalState,
  getStatusMessage,
  getCannotUpdateMessage
};